import React from 'react';
import { StackItem } from '@domain-group/fe-blueprint-ui/layout';
import * as styles from '../average-star-rating-and-total.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var TotalReviewsText = _ref => {
  var size = _ref.size,
    totalReviews = _ref.totalReviews;
  return ___EmotionJSX(StackItem, {
    css: styles.totalReview(size),
    align: "center",
    id: "total-rating",
    as: "span"
  }, "(", totalReviews, " reviews)");
};
export default TotalReviewsText;